import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { NgZone } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT',
    'Access-Control-Allow-Credentials': 'true',
  })
};

@Injectable({
  providedIn: 'root'
})
export class UmsService {
 
  constructor(private http: HttpClient, public snackBar: MatSnackBar,
              private router: Router, private location: Location,) {
    this.APIService = environment.serviceUrl;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }
  private tclcData: any;
  private payData: any;
  private sharedData: string;
  private userTypeSubject = new BehaviorSubject<string | null>(null); 
  userType$ = this.userTypeSubject.asObservable();

    tabStatus = {
    personalTab: false,
    contactTab: false,
    reservationTab: false,
    additionalTab: false,
    qualificationTab: false,
    photoSignatureTab: false,
    admissionTab: false,
    documentTab: false,
  };

  tabMapping = {
  'Personal Details': 'personalTab',
  'Contact Details': 'contactTab',
  'Reservations Details': 'reservationTab',
  'Additional Details': 'additionalTab',
  'Qualification Details': 'qualificationTab',
  'Photo Signature': 'photoSignatureTab',
  'Admission Details': 'admissionTab',
  'Wrong Payment': 'admissionTab',
  'Document Upload': 'documentTab'
};

  setTabSaved(tabName: string) {
    this.tabStatus[tabName] = true;
  }

  isRequiredTabsSaved(tabs?: string): boolean {
    if (!tabs) {
    return false;
  }
  const requiredTabs = [...new Set(
    tabs.split(',').map(x => x.trim())
  )];
  //  console.log('requiredTabs', requiredTabs);

  return requiredTabs.every(tab => {
    const key = this.tabMapping[tab];
    // console.log('tab=', tab, 'key=', key);
    return key ? this.tabStatus[key] : false;
  });
}

  resetTabs() {
    Object.keys(this.tabStatus).forEach(key => {
      this.tabStatus[key] = false;
    });
  }

  setUserType(value: string) {
    this.userTypeSubject.next(value);
    sessionStorage.setItem('userType', value); // Persist value for page refresh
  }

  getUserType(): string | null {
    return sessionStorage.getItem('userType');
  }

  setData(data: string) {
    this.sharedData = data;
  }

  getData(): string {
    return this.sharedData;
  }

  setTclcData(data: any) {
    this.tclcData = data;
  }

  getTclcData() {
    return this.tclcData;
  }

  setpayDetails(data: any) {
    this.payData = data;
  }

  getpayDetails() {
    return this.payData;
  }
  private Session: any;

  getCurrentSession(data: any){
      return this.Session = data;
  }
  private history: string[] = [];
  private APIService: string = environment.serviceUrl; // this has to be load from an external config file
  public studentProgressList:any = [];
  public disable : Boolean = true;
  public disable1: Boolean = true;
  public disable2 : Boolean = true;
  public disable3: Boolean = true;
  public disable4 : Boolean = true;
  public disable5 : Boolean = true;
  public disable6 : Boolean = true;
  public disable7 : Boolean = true;
  public disable8 : Boolean = true;
  public profileIcon: any;
  public profileIcon2: any;
   Exam; Semester;

  deleteuserroleData(id: any) {
    throw new Error('Method not implemented.');
  }

  geticon(){
    return this.profileIcon =  sessionStorage.getItem('ProfileImg');
  }
getImage(e){
  this.profileIcon = e
}

getNoimg(e){
  this.profileIcon2 = e
}
getNoicon(){
  return this.profileIcon2 = sessionStorage.getItem('ProfileImg')
}
  openSnackbar(message: string) {
    return this.snackBar.open(message, 'close',
      { verticalPosition: 'top', horizontalPosition: 'center', duration: 200, panelClass: ['snackbarStyle'] });
  }
  getStudentMenu(): Observable<any> {
    return this.http.get(this.APIService + '/menu/students').pipe();
  }

  getTeachersMenu(): Observable<any> {
    return this.http.get(this.APIService + '/menu/teachers').pipe();
  }

  getParentsMenu(): Observable<any> {
    return this.http.get(this.APIService + '/menu/parents').pipe();
  }

  login(payload): Observable<any> {
    return this.http.post(this.APIService + '/login/Stulogin', payload).pipe();
  }
 
  getDistrict(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/district/fetch', payload).pipe();
  }

  getStateWiseDistrict(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/StateWiseDistrict/fetch', payload).pipe();
  }

  addDistrict(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/district', payload).pipe();
  }

  updateDistrict(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/district', payload).pipe();
  }

  searchDistrict(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/district/fetch', payload).pipe();
  }

  deleteDistrict(payload): Observable<any> {
    return this.http.delete(this.APIService + '/masters/district', payload).pipe();
  }

  getCountry(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/country/fetch', payload).pipe();
  }

  addCountry(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/country', payload).pipe();
  }

  getCountryWiseState(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CountryStateWise/fetch', payload).pipe();
  }

  getTown(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/town/fetch', payload).pipe();
  }

  addTown(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/town', payload).pipe();
  }

  updateTown(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/town', payload).pipe();
  }

  searchTown(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/town/fetch', payload).pipe();
  }

  deleteTownnn(payload): Observable<any> {
    return this.http.delete(this.APIService + '/masters/town', payload).pipe();
  }

  addCode(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code', payload).pipe();
  }

  updateCode(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/code', payload).pipe();
  }
 getCourseLevel(): Observable<any> {
    return this.http.post(this.APIService + '/masters/code-types/fetch', {"CdType":"COLSR"}).pipe();
  }

  getCourseData(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/course/fetch', payload).pipe();
  }
  CourseWiseCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/college-course/fetch', payload).pipe();
  }
  getCode(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code/fetch', payload).pipe();
  }

  searchCode(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code/fetch', payload).pipe();
  }

  addCodeType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code-types', payload).pipe();
  }

  updateCodeType(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/code-types', payload).pipe();
  }

  getCertCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CertificateCourses/fetch', payload).pipe();
  }

  getCodeType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code-types/fetch', payload).pipe();
  }

  searchCodeType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code-types/fetch', payload).pipe();
  }

  getFeeTemplet(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feetemplate/fetch', payload).pipe();
  }

  getPracticalTimeTable(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/PracticalTimeTable/fetch', payload).pipe();
  }

  getExamTT(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/SearchExamTime/fetch', payload).pipe();
  }

  getExamHoliday(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GetHolidayDate/fetch', payload).pipe();
  }

  getSecretData(): Observable<any> {
    return this.http.get(this.APIService + '/security/SecreatData').pipe();
  }

  ExmFrmEditListCo(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/NewRegnFormEditListCo/Fetch', payload).pipe();
  }

  fetchInputExams(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchEditExamForm/fetch', payload).pipe();
  }

  fetchEcid(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/GetLatestEcId/fetch', payload).pipe();
  }

  fetchLatestEcid(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/GetNextExam/fetch', payload).pipe();
  }

  updateRegnFormsByRgNo(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/UpdateRegnFormsByRgNo', payload).pipe();
  }

  GetEcId(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/GetEcIdStud/fetch', payload).pipe();
  }

  getExamSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ExamSchedule/fetch', payload).pipe();
  }

  getExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GetLatestExam/fetch', payload).pipe();
  }

  getExamForStudent(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam/fetch', payload).pipe();
  }

  RgId(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/getRgDetails/fetch', payload).pipe();
  }

  SaveExmFrm(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditFormSub', payload).pipe();
  }

  ExmFormSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditFormSub/fetch', payload).pipe();
  }

  getIAAtd(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttndDetailsIAHead/fetch', payload).pipe();
  }

  NewvalidateGenExams(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/NewVldtEditExamForms', payload).pipe();
  }

  GetStuSubject(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GetStuSubject/fetch', payload).pipe();
  }

  NewCoSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/get_NewCousreSchedule', payload).pipe();
  }

  NewSearchCoSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/get_NewSearchCoEditSchedule', payload).pipe();
  }

  RegnTemp(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/NewRegnFormsTemp', payload).pipe();
  }

  getExamSubMapFetch(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-subject-mapping/fetch', payload).pipe();
  }

  getOption(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/EsOptions/fetch',payload).pipe();
  }

  ValidateTemp(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/VldtEditRegnFormsTemp', payload).pipe();
  }

  checkTemp(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/get_checkTempRegVldt', payload).pipe();
  }

  StuAttendance(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendance/fetch', payload).pipe();
  }

  StuAttendanceNewSem(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceNewSem/fetch', payload).pipe();
  }

  findSessionCutOff(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoColgCutOff/fetch', payload).pipe();
  }

  fetchExamRegList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditExamFormDrpList/fetch', payload).pipe();
  }

  getSupExamEditRecord(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examEditControl/fetch',payload).pipe();
  }

  PutvalidateGeneratedExams(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/VldtEditExamForms', payload).pipe();
  }

  getExamStream(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-stream/branch/fetch', payload).pipe();
  }

  getFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/FeesByPass/fetch', payload).pipe();
  }

  ValidateFees(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/ValidateFees/fetch', payload).pipe();
  }
  
  getCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/collage/fetch', payload).pipe();
  }

  GenExmForm(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/NewgenProcNewEf', payload).pipe();
  }

  getPayFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/PayFeeDetails', payload).pipe();
  }

  getSearchFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeeDetails', payload).pipe();
  }

  
  getSearchTranscriptFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchTranscriptFeeDetails', payload).pipe();
  }

  addFeeTemplet(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/PayFeeDetails', payload).pipe();
  }

  updateFeeTemplet(payload): Observable<any> {
    return this.http.put(this.APIService + '/fees/PayFeeDetails', payload).pipe();
  }

    addUser(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/user', payload).pipe();
    }
  
    updateUser(payload): Observable<any> {
      return this.http.put(this.APIService + '/masters/user', payload).pipe();
    }
  
    getUser(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/user/fetch', payload).pipe();
    }

    searchUser(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/user/fetch', payload).pipe();
    }

    getUserData(id): Observable<any> {
      return this.http.get(this.APIService + '/security/get-login-master/' + id+'/10/1/0').pipe();
    }

    addStdSetting(payload): Observable<any> {
      return this.http.post(this.APIService + '/stuFormSettings/StuFormDetails', payload).pipe();
    }

    updateStdSetting(payload): Observable<any> {
      return this.http.put(this.APIService + '/stuFormSettings/StuFormDetails', payload).pipe();
    }

    getStdSetting(payload): Observable<any> {
      return this.http.post(this.APIService + '/stuFormSettings/StuFormDetails/fetch', payload).pipe();
    }

    addpersonalDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/personalDetails', payload).pipe();
    }

    fetchPersonalDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/personalDetails/fetch', payload).pipe();
    }

    updatePersonalDetails(payload): Observable<any> {
      return this.http.put(this.APIService + '/students/personalDetails', payload).pipe();
    }
    
    addContactDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/AddressDetails', payload).pipe();
    }

    fetchContactDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/AddressDetails/fetch', payload).pipe();
    }

    updateContactDetails(payload): Observable<any> {
      return this.http.put(this.APIService + '/students/AddressDetails', payload).pipe();
    }

  SearchFeeAdm(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeetemp_Adm/fetch', payload).pipe();
  }

  OldReceiptAdm(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/GetStudentOldFeeReceipts/fetch', payload).pipe();
  }

  CompareFeeAdm(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/GetAdminFeeTemplateByStudent/fetch', payload).pipe();
  }
  
    fetchCodeType(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/code-types/fetch', payload).pipe();
    }

    addReservationDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/Reservation', payload).pipe();
    }

    fetchReservationDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/Reservation/fetch', payload).pipe();
    }

    updateReservationDetails(payload): Observable<any> {
      return this.http.put(this.APIService + '/students/Reservation', payload).pipe();
    }
   
    fetchMinority(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/MinorityType/fetch', payload).pipe();
    }

    fetchCategory(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/CasteList/fetch', payload).pipe();
    }

    addQualificationDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/Qualification', payload).pipe();
    }

    fetchQualificationDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/Qualification/fetch', payload).pipe();
    }

    updateQualificationDetails(payload): Observable<any> {
      return this.http.put(this.APIService + '/students/Qualification', payload).pipe();
    }
    StudentEntranceDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/Entrance', payload).pipe();
    }
     fetchStudentEntrance(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/Entrance/fetch', payload).pipe();
    }
    deleteQualificationDetails(payload): Observable<any> {
      return this.http.delete(this.APIService + '/students/Qualification', payload).pipe();
    }

    addAdditionalDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/AdditionalDetails', payload).pipe();
    }

    fetchAdditionalDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/AdditionalDetails/fetch', payload).pipe();
    }

    updateAdditionalDetails(payload): Observable<any> {
      return this.http.put(this.APIService + '/students/AdditionalDetails', payload).pipe();
    }

    SchExmFrm(payload): Observable<any> {
      return this.http.post(this.APIService + '/inputs/SearchExamForm/fetch', payload).pipe();
    }

    fetchCourseType(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/course/fetch', payload).pipe();
    }

    fetchFaculty(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/faculty/fetch', payload).pipe();
    }

    fetchCourseBranch(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/exam-stream/branch/fetch', payload).pipe();
    }

    fetchExam(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/exam/fetch', payload).pipe();
    }

    studRegistrationDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/login/StuReg', payload).pipe();
    }

    fetchPhotoSignDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/StudentPhotoAndSign/fetch', payload).pipe();
    }

    addAddmissionDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/AdmissionDetails', payload).pipe();
    }
  StudentOtherDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/OtherDetails', payload).pipe();
  }
    fetchAddmissionDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/AdmissionDetails/fetch', payload).pipe();
    }

    getAssignLevel(payload): Observable<any> {
      return this.http.post(this.APIService + '/admin/AssignRole/fetch', payload).pipe();
    }

    fetchstucourseClgMap(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/stucourseClgMap/fetch', payload).pipe();
    }

    updateAddmissionDetails(payload): Observable<any> {
      return this.http.put(this.APIService + '/students/AdmissionDetails', payload).pipe();
    }

    addPhotoSignDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/StudentPhotoAndSign', payload).pipe();
    }

    addDocumentDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/StuDocumentUpload', payload).pipe();
    }

    fetchDocumentDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/StuDocumentUpload/fetch', payload).pipe();
    }
    getFilesDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/GetFile', payload).pipe();
    }
      saveFiles(payload): Observable<any> {
      return this.http.post(this.APIService + '/document/testUpload', payload).pipe();
    }
   fetchDocument(payload): Observable<any> {
      return this.http.post(this.APIService + '/document/fetchDocument', payload).pipe();
    }
    GetTcLcDocDetailsFile(payload): Observable<any> {
  return this.http.post(this.APIService + '/document/GetTcLcDocDetails', payload);
}
    fetchStudDocumentDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/StudentDocumentRequirements/fetch', payload).pipe();
    }

    updateDocumentDetails(payload): Observable<any> {
      return this.http.put(this.APIService + '/students/StuDocumentUpload', payload).pipe();
    }

    AddScrtDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/admin/ScrutinyDetails', payload).pipe();
    }

    UpdScrtDetails(payload): Observable<any> {
      return this.http.put(this.APIService + '/admin/ScrutinyDetails', payload).pipe();
    }

    openSessionActivities(payload): Observable<any> {
      return this.http.get(this.APIService + '/supervisor/OpenActivities', payload).pipe();
    }

    studentCompSummary(payload): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/StudentCompleteSummary/fetch', payload).pipe();
    }

    fetchSubs(payload): Observable<any> {
      return this.http.post(this.APIService + '/inputs/ExamSubRg/fetch', payload).pipe();
    }

    fetchScrutinyLock(payload): Observable<any> {
      return this.http.post(this.APIService + '/lock/ScrutinyLock', payload).pipe();
    }

    updatePhotoSignDetails(payload): Observable<any> {
      return this.http.put(this.APIService + '/students/StudentPhotoAndSign', payload).pipe();
    }
  
    SendEmail(payload): Observable<any> {
      return this.http.post(this.APIService + '/login/emailOtp', payload).pipe();
    }

    fetchCheckFeeMode(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/CheckFeeMode/fetch', payload).pipe();
    }

    fetchFeeTemp(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/SearchFeetemp', payload).pipe();
    }

    fetchFeeTempTclc(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/SearchFeetempTclc', payload).pipe();
    }

    getTehasil(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/Tehsil/fetch', payload).pipe();
    }

    getDistrictWiseTehasil(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/DistrictWiseTehsil/fetch', payload).pipe();
    }

    SetReportParam(payload): Observable<any> {
      return this.http.post(this.APIService + '/report/SetReportParam', payload).pipe();
    }

    renderReport(payload): Observable<any> {
    return this.http.post('http://umsreportsapidevedition.universus.co.in/api/Reports/UMS/RenderReportV2',payload,{responseType: 'blob'})  
    //  return this.http.post('https://ssuhsreports.universus.co.in/api/Reports/UMS/RenderReportV2', payload, { responseType: 'blob' })
  }
    generateQR(payload): Observable<any> {
      return this.http.post(this.APIService + '/abcID/generateQR', { data: payload }).pipe();
    }
    getOpenSession(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/openSessions/fetch', payload).pipe();
    }

    getStuSubject(payload): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/GetStuSubject/fetch', payload).pipe();
    }

    getSession(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/session/fetch', payload).pipe();
    }

    listSessionCutOff(payload): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/CheckAdmissionDate/fetch',payload).pipe();
    }

    SearchSessionCutOff(payload): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/CheckAdmissionDate/fetch',payload).pipe();
    }

    getCourse(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/course/fetch', payload).pipe();
    }

    CheckValidDate(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/CheckValidDate/fetch',payload).pipe();
    }

    listSession(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/SessionCoColgCutOfflist/fetch',payload).pipe();
    }

    applyDate(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/StuAdmFrmDtls',payload).pipe();
    }

    searchCourseQualification(payload): Observable<any> {
      return this.http.post(this.APIService + '/stuFormSettings/SearchCourseQualiConfig/fetch',payload).pipe();
    }

    CheckExamEligibility(payload): Observable<any> {
      return this.http.post(this.APIService + '/admin/CheckExamEligibility',payload).pipe();
    }

    getApplyData(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/StuAdmFrmDtls/fetch', payload).pipe();
    }

    getCuttoffDate(payload): Observable<any> {
      return this.http.post(this.APIService + '/login/StuAdmFrmDtls/fetch', payload).pipe();
    }

    getDownloadDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/StudentDownloadDocument/fetch', payload).pipe();
    }

    paymentgateway(payload): Observable<any> {
      return this.http.post(this.APIService + "/fees/payment", payload).pipe();
    }

    saveApplicationDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/ApplicationTrackDate', payload).pipe();
    }

    fetchApplicationDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/ApplicationTrackDate/fetch', payload).pipe();
    }

    addSubjectSelectionDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/StudentSubjectSelection', payload).pipe();
    }

    updateSubjectSelectionDetails(payload): Observable<any> {
      return this.http.put(this.APIService + '/students/StudentSubjectSelection', payload).pipe();
    }

    getSubSelectionDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/StudentSubjectSelection/fetch', payload).pipe();
    }

    AllSnNoReports(payload): Observable<any> {
      return this.http.post(this.APIService + '/report/AllSnNoReports/fetch', payload).pipe();
    }

    DistrictWiseCollege(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/DistrictWiseCollege/fetch', payload).pipe();
    }

    addReadmissionDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/Re_AdmControl', payload).pipe();
    }

    StudentSubjectSelectionById(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/StudentSubjectSelectionById/fetch', payload).pipe();
    }

    AddTclc(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/tclcmc', payload).pipe();
    }

    UpdateTclc(payload): Observable<any> {
      return this.http.put(this.APIService + '/students/tclcmc', payload).pipe();
    }

    GetTclc(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/tclcmc/fetch', payload).pipe();
    }

    GetUniversity(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/university/fetch', payload).pipe();
    }

    GetTclcData(payload): Observable<any> {
      return this.http.post(this.APIService + '/admin/tclcData/fetch', payload).pipe();
    }

    AddTclcDoc(payload): Observable<any> {
      return this.http.post(this.APIService + '/admin/AddDocsDetails', payload).pipe();
    }

    UpdateTclcDoc(payload): Observable<any> {
      return this.http.put(this.APIService + '/admin/UpdateDocsDetails', payload).pipe();
    }

    GetTcLcDocDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/admin/tclcDocDetails/fetch', payload).pipe();
    }

    GetStuAddress(payload): Observable<any> {
      return this.http.post(this.APIService + '/admin/GetStuAddress/fetch', payload).pipe();
    }

    GetTcLcDocs(payload): Observable<any> {
      return this.http.post(this.APIService + '/admin/tclcDocs/fetch', payload).pipe();
    }

    AddTranscript(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/Transcript', payload).pipe();
    }

    UpdateTranscript(payload): Observable<any> {
      return this.http.put(this.APIService + '/fees/Transcript', payload).pipe();
    }

    SearchTranscript(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/SearchTranscript/fecth', payload).pipe();
    }

    CommonDocument(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/CommonDocumentDetails/fetch', payload).pipe();
    }

    ExamFetch(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/exam/fetch', payload).pipe();
    }

    updateReadmissionDetails(payload): Observable<any> {
      return this.http.put(this.APIService + '/students/Re_AdmControl', payload).pipe();
    }

    getSessionIntakeCutoff(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/CastewiseIntake/fetch', payload).pipe();
    }

    getCasteCount(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/CasteWiseAdmissionCount', payload).pipe();
    }

    forgotPassword(payload): Observable<any> {
      return this.http.put(this.APIService + '/security/forget-passwordForStud', payload).pipe();
    }

    changePassword(payload): Observable<any> {
      return this.http.put(this.APIService + '/security/change-passwordForStud', payload).pipe();
    }

    addComplaint(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/Grievances', payload).pipe();
    }

    getComplaint(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/Grievances/fetch', payload).pipe();
    }

    updateComplaint(payload): Observable<any> {
      return this.http.put(this.APIService + '/masters/Grievances', payload).pipe();
    }

    getDepartment(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/Departments/fetch', payload).pipe();
    }

    addComment(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/Grievance_Comments', payload).pipe();
    }

    getComment(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/Grievance_Comments/fetch', payload).pipe();
    }

    GetFailStudStatus(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/GetFailStudStatus/fetch', payload).pipe();
    }

    getAction(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/Grievance_Actions/fetch', payload).pipe();
    }

    getActionComment(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/GetGrievance_ActionsAndComments/fetch', payload).pipe();
    }

    getSupCourseEditRecord(payload): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/courseEditControl/fetch', payload).pipe();
    }

    payZeroFee(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/paymentresponse', payload).pipe();
    }

    payBeforeScrutiny(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/SearchFeetemp_AdmBfrSct/fetch', payload).pipe();
    }

    addRegiFormScrutiny(payload): Observable<any> {
      return this.http.post(this.APIService + '/inputs/NewRegnForms', payload).pipe();
    }

    validateRegiForm(payload): Observable<any> {
      return this.http.put(this.APIService + '/inputs/VldtEditRegnForms', payload).pipe();
    }

    getPaymentGateway(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/paymentGatewayType/fetch', payload).pipe();
    }

    RazorPayOrder(payload): Observable<any> {
      return this.http.post(this.APIService + '/payment/create-order', payload).pipe();
    }

    checkRazorPayOrder(payload): Observable<any> {
      return this.http.post(this.APIService + '/payment/verify-payment', payload).pipe();
    }
    
getRazorPayOrder(id): Observable<any> {
  return this.http.get(this.APIService + "/payment/fetch-order/" + id).pipe();
}

saveRazorPayResponse(payload): Observable<any> {
  return this.http.post(this.APIService + "/payment/razorpayResponse" , payload).pipe();
}
    GetTcLcDocUploadDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/admin/tclcDocUploadDetails/fetch', payload).pipe();
    }

    savePaymentResponse(payload): Observable<any> {
      return this.http.post(this.APIService + "/fees/paymentresponse" , payload).pipe();
    }
    
    fetchStudentProgress(payload): Observable<any> {
      return this.http.post(this.APIService + '/masters/TabsTrueFalse/fetch', payload).pipe();
    }
    
    fileUpload(formData: FormData): Observable<any> {
      return this.http.post(this.APIService + '/fileUpload/upload',formData).pipe();
    }

    SendMobile(payload): Observable<any> {
      return this.http.post(this.APIService + '/login/sendMobileOtp', payload).pipe();
    }

    VerifyMobile(payload): Observable<any> {
      return this.http.post(this.APIService + '/login/VerifyMobOtp', payload).pipe();
    }

    GetProvisional(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/Provisional/fetch', payload).pipe();
    }

    GetOriginalPassCertificate(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/Passing/fetch', payload).pipe();
    }

    GetMigration(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/Migration/fetch', payload).pipe();
    }

    GetRankCertificate(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/Rank/fetch', payload).pipe();
    }

    SearchTranscriptProvisional(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/Provisional/fetch', payload).pipe();
    }

    AddProvisional(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/Provisional', payload).pipe();
    }

    AddOriginalPassing(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/Passing', payload).pipe();
    }

    AddMigration(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/Migration', payload).pipe();
    }

    AddRank(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/Rank', payload).pipe();
    }

    UpdateProvisional(payload): Observable<any> {
      return this.http.put(this.APIService + '/fees/Provisional', payload).pipe();
    }

    UpdateOriginalPassing(payload): Observable<any> {
      return this.http.put(this.APIService + '/fees/Passing', payload).pipe();
    }

    UpdateMigration(payload): Observable<any> {
      return this.http.put(this.APIService + '/fees/Migration', payload).pipe();
    }

    UpdateRank(payload): Observable<any> {
      return this.http.put(this.APIService + '/fees/Rank', payload).pipe();
    }
    

    getFeeStatus(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/FeeStatus/fetch', payload).pipe();
    }

    getAdmittedData(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/AdmittedStudentData/fetch', payload).pipe();
    }

    checkUnClearedSinglePayment(payload): Observable<any> {
      return this.http.post(this.APIService + '/payment/checkUnClearedSinglePayments', payload).pipe(); 
    }

    ValidateCertificateFees(payload): Observable<any> {
      return this.http.post(this.APIService + '/fees/ValidateCertificateFees/fetch', payload).pipe();
    }

    // /security/UpdatePrnNo
    updatePRN(payload): Observable<any> {
      return this.http.post(this.APIService + '/security/UpdatePrnNo', payload).pipe(); 
    }
    downloadFile(data, filename= 'data', e) {
      const csvData = this.ConvertToCSV(data, e);
      const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
      const dwldLink = document.createElement('a');
      const url = URL.createObjectURL(blob);
      const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
      if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
          dwldLink.setAttribute('target', '_blank');
      }
      dwldLink.setAttribute('href', url);
      dwldLink.setAttribute('download', filename + '.csv');
      dwldLink.style.visibility = 'hidden';
      document.body.appendChild(dwldLink);
      dwldLink.click();
      document.body.removeChild(dwldLink);
  }

  ConvertToCSV(objArray, headerList) {
       const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
       let str = '';
       let row = 'S.No,';

       // tslint:disable-next-line:forin
       for (const index in headerList) {
           row += headerList[index] + ',';
       }
       row = row.slice(0, -1);
       str += row + '\r\n';
       for (let i = 0; i < array.length; i++) {
           let line = (i + 1) + '';
           // tslint:disable-next-line:forin
           for (const index in headerList) {
              const head = headerList[index];

              line += ',' + array[i][head];
           }
           str += line + '\r\n';
       }
       return str;
   }
}

